import { AuthService } from "../authentication/services/auth.service";
import { Injectable, inject } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateFn,
  Router,
} from "@angular/router";
import { catchError, map, Observable, of } from "rxjs";
import { LogService } from "../../shared/service/logging/log.service";

@Injectable({ providedIn: "root" })
export class AuthGuardService {
  auth = inject(AuthService);
  router = inject(Router);
  logger = inject(LogService);

  private isLoggedIn$ = this.auth.isLoggedIn$;

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return this.isLoggedIn$.pipe(
      map((isLoggedIn) => {
        if (!isLoggedIn) {
          this.logger.debug("Need to log in!!");
          this.auth.redirectToLogin();
        }
        return isLoggedIn;
      }),
      catchError(() => {
        this.auth.redirectToLogin();
        return of(false);
      })
    );
  }
}

export const AuthGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Observable<boolean> => {
  return inject(AuthGuardService).canActivate(next, state);
};
